import { atom, atomFamily, selector, selectorFamily } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

export const MAP_ID_TILEMAP = 'MAP_ID_TILEMAP';
export const MAP_ID_LONLAT = 'MAP_ID_LONLAT';
export const MAP_ID_FIR = 'MAP_ID_FIR';
export const MAP_ID_AIRPORT = 'MAP_ID_AIRPORT';
export const MAP_ID_FIX = 'MAP_ID_FIX';
export const MAP_ID_AIRWAY = 'MAP_ID_AIRWAY';
export const MAP_ID_NAVAIDS = 'MAP_ID_NAVAIDS';
export const MAP_ID_FLIGHTPLAN = 'MAP_ID_FLIGHTPLAN';
export const MAP_ID_COASTLINE = 'MAP_ID_COASTLINE';

const mapContentsVisibleFamily = atomFamily({
  key: 'mapContentsVisibleFamily',
  default: selectorFamily({
    key: 'mapContentsVisibleFamilySelector',
    get: param => () => {
      return getCustomerSettings(`layerConfig.${param}.checked`);
    }
  })
});

export const selectedMapContentsList = atom({
  key: 'selectedMapContentsList',
  default: selector({
    key: 'selectedMapContentsListSelector',
    get: () => {
      const layerConfig = getCustomerSettings('layerConfig');
      const menuOtherOrder = getCustomerSettings('menuOtherOrder');
      const list = [];
      menuOtherOrder.forEach(other => {
        if(layerConfig[other].checked) {
          list.push(other);
        }
      });
      return list;
    }
  })


});

export const mapContentsVisibleWithID = selectorFamily({
  key: 'mapContentsVisibleWithID',

  get: (id) => ({get}) => {
    return get(mapContentsVisibleFamily(id));
  },

  set: (id) => ({set, get}, newValue) => {
    set(mapContentsVisibleFamily(id), newValue);
    const oldList = get(selectedMapContentsList);
    let newList;
    if (newValue) {
      newList = [...oldList, id];
    } else {
      const index = oldList.findIndex(_id => _id === id);
      if (index === -1) return;
      newList = [...oldList.slice(0, index), ...oldList.slice(index + 1)]
    }
    set(selectedMapContentsList, newList);
  }
});

export const toggleMapContentsVisibleWithID = selectorFamily({
  key: 'toggleMapContentsVisibleWithID',
  set: (id) => ({set, get}) => {
    const visible = get(mapContentsVisibleWithID(id))
    set(mapContentsVisibleWithID(id), !visible);
  }
});
